export { ReactComponent as WorkFlowPlusHeaderLogo } from './header-logo.svg';
